import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState } from 'react';
import { TaiIcon } from './TaiIcon.js';
import { TaskRow } from './TaskList.js';
export function HighlightCard({ tasks, usage, focusedId, onFocusTask, onToggle, onToggleHighlight, onMove, labels, }) {
    const headingId = useId();
    if (tasks.length === 0)
        return null;
    return (_jsxs("section", { className: "tai-card", "aria-labelledby": headingId, children: [_jsxs("h2", { id: headingId, className: "tai-card__title", children: [_jsx(TaiIcon, {}), " ", labels.title, _jsx("span", { className: "tai-card__usage", children: usage })] }), _jsx("ul", { className: "task-group__list", "aria-labelledby": headingId, children: tasks.map((task) => (_jsx(TaskRow, { task: task, focused: focusedId === task.id, onFocus: onFocusTask, onToggle: onToggle, onToggleHighlight: onToggleHighlight, onMove: onMove, labels: labels }, task.id))) })] }));
}
/** «Tarea completada · Deshacer» for 5 s, announced politely. */
export function UndoToast({ toastKey, message, onUndo, onExpire, durationMs = 5000, labels, }) {
    const expire = useRef(onExpire);
    useEffect(() => {
        expire.current = onExpire;
    });
    useEffect(() => {
        const timer = setTimeout(() => expire.current(), durationMs);
        return () => clearTimeout(timer);
    }, [toastKey, durationMs]);
    return (_jsxs("div", { className: "undo-toast", role: "status", "aria-live": "polite", children: [_jsx("span", { children: message }), _jsx("button", { type: "button", className: "undo-toast__undo", onClick: onUndo, children: labels.undo })] }));
}
/** Destinations of «Mover a…»: a small dialog with one button per stage, arrows to move. */
export function MoveMenu({ title, options, onChoose, onCancel, labels }) {
    const titleId = useId();
    const [active, setActive] = useState(0);
    const buttons = useRef([]);
    useEffect(() => {
        buttons.current[active]?.focus();
    }, [active]);
    return (_jsx("div", { className: "dialog", role: "presentation", children: _jsxs("div", { className: "dialog__panel move-menu", role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, onKeyDown: (event) => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    onCancel();
                }
                else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                    event.preventDefault();
                    const step = event.key === 'ArrowDown' ? 1 : -1;
                    setActive((index) => (index + step + options.length) % options.length);
                }
            }, children: [_jsx("h2", { id: titleId, className: "dialog__title", children: title }), _jsx("ul", { className: "move-menu__list", children: options.map((option, index) => (_jsx("li", { children: _jsx("button", { ref: (element) => {
                                buttons.current[index] = element;
                            }, type: "button", className: "move-menu__option", onClick: () => onChoose(option.id), children: option.label }) }, option.id))) }), _jsx("div", { className: "dialog__actions", children: _jsx("button", { type: "button", onClick: onCancel, children: labels.cancel }) })] }) }));
}
/** A question with a few answers, e.g. «¿Completar también las 3 subtareas?» (docs/04 §3 rule 7). */
export function ChoiceDialog({ title, message, choices, onChoose, onCancel, labels, }) {
    const titleId = useId();
    const messageId = useId();
    const first = useRef(null);
    useEffect(() => first.current?.focus(), []);
    return (_jsx("div", { className: "dialog", role: "presentation", children: _jsxs("div", { className: "dialog__panel", role: "alertdialog", "aria-modal": "true", "aria-labelledby": titleId, "aria-describedby": messageId, onKeyDown: (event) => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    onCancel();
                }
            }, children: [_jsx("h2", { id: titleId, className: "dialog__title", children: title }), _jsx("p", { id: messageId, className: "dialog__message", children: message }), _jsxs("div", { className: "dialog__actions", children: [_jsx("button", { type: "button", onClick: onCancel, children: labels.cancel }), [...choices].reverse().map((choice) => (_jsx("button", { ref: choice.id === choices[0]?.id ? first : undefined, type: "button", className: choice.id === choices[0]?.id ? 'dialog__primary' : undefined, onClick: () => onChoose(choice.id), children: choice.label }, choice.id)))] })] }) }));
}
//# sourceMappingURL=ListParts.js.map